module.exports = __webpack_public_path__ + "img/backburger.e1366c3d.svg";